import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const outgoingRfqsSlice = createSlice({
    name: 'ui/outgoing-rfqs',
    initialState,
    reducers: listReducers
})

export const outgoingRfqsActions = outgoingRfqsSlice.actions
export default outgoingRfqsSlice.reducer
